export const iic=[
    {
        'id':'1',
        'program':'ACGCET Innovation and startup policy 2022-AISP 2022',
        'pdf':'https://drive.google.com/file/d/1u6t1dl0KueD1KnGh9HnqRDBCk_LdEKgz/view?usp=sharing'
    },
    {
        'id':'2',
        'program':'National Innovation and startup policy 2019-NISP 2019',
        'pdf':'https://drive.google.com/file/d/1yqcuKoeLQyBWeEdhns5GalDoUM0Dbb97/view?usp=sharing'
    },
    {
        'id':'3',
        'program':'Tamilnadu Startup Policy 2018-2023',
        'pdf':'https://drive.google.com/file/d/1zK0Q2sRIieR7LFCrDjn2vQMVMxMybY8S/view?usp=sharing'
    },
]

export const edc=[
    {
        id : 1,
        program :'IIC Activity Report Q1 2021-22 EDC Startup Founder A Jagadesh 24.08.2021',
        pdf : 'https://drive.google.com/file/d/14S2FchOhVBWUycf0L1AjIuTzWSs-TBsu/view?usp=drive_link',
    },
    {
        id : 2,
        program :'1c. IEDP Report EDII-IEDP Prog 12.11.2021',
        pdf : 'https://drive.google.com/file/d/1yWBa2zl1vdGfnj7p4_GY-PKSHKBjXjK2/view?usp=drive_link',
    },
    {
        id : 3,
        program :'IITM Buildclub event  17-18.06.2022',
        pdf : 'https://drive.google.com/file/d/1t8HA09s36AoJgbD2oyAYzsN84-60-LZ2/view?usp=drive_link',
    },
    {
        id : 4,
        program :'List of EDC Programs 21 -22',
        pdf : 'https://drive.google.com/file/d/1eI700J91iPppKWH1YbQwveBJLUjwjRkE/view?usp=sharing',
    },
    {
        id : 5,
        program :'List of EDC Programs 22-23',
        pdf : 'https://drive.google.com/file/d/1ewqqGPXVB1lMjI4M9t5dZo109gH503Ir/view?usp=sharing',
    },
    {
        id : 6,
        program :'List of EDC Programs 23-24',
        pdf : 'https://drive.google.com/file/d/1_VdDLIk_yTBA4ygoI7UO8Od_n7IySDm3/view?usp=sharing',
    },
    {
        id : 7,
        program :'Q1 IIC CalenderActivity Workshop on Entrepreneurship & Innovation ',
        pdf : 'https://drive.google.com/file/d/1zfENW4WCUdU7lnF30b0ihztrsQrnb3eG/view?usp=sharing',
    },
    {
        id : 8,
        program :'Q2 Ent-ship Attidude Beh. Dev 26 to 28.12.2023',
        pdf : 'https://drive.google.com/file/d/1AvzpxEYlpdZhckPOvdBvwdMAKetjSJFD/view?usp=sharing',
    },
    {
        id : 9,
        program :'Q2 II Session on Achieving Problem Solution Fit & Product Market Fit',
        pdf : 'https://drive.google.com/file/d/1N9i8djg5YA1SKzkwLW3zLljMXxn1fqfW/view?usp=sharing',
    },
    {
        id : 10,
        program :'Q2 IIC Calender Activity Problem fit solution 28.12.2023',
        pdf : 'https://drive.google.com/file/d/1Os36K1ns8SLxYX1IVRD39xe_5Q0d94A_/view?usp=sharing',
    },
    {
        id : 11,
        program :'Q2 IIC Calender Activity Design Thinking 26.12.2023',
        pdf : 'https://drive.google.com/file/d/1DHDVLzMNgaPYMrVBTCOsYfw0M7GMELF4/view?usp=sharing',
    },
    {
        id : 12,
        program :'Q2 IIC Calender Activity Workshop Entrepreneurship Skill,Attitude & Behaviour Devel.',
        pdf : 'https://drive.google.com/file/d/1M7ve51owfFQb8YKV0vDODvpynuv0SNUK/view?usp=sharing',
    },
    {
        id : 13,
        program :'Q2 IIC Niral Hackathon 22 to 27.01.2024 merged',
        pdf : 'https://drive.google.com/file/d/1q60zYQf6hlwXKB24s9eoCxgWCj1UeQLC/view?usp=sharing',
    },
    {
        id : 14,
        program :'Q3 IIC Calender Activity 15.03.2022',
        pdf : 'https://drive.google.com/file/d/13LyNgBWOmRaa6PyEoQFcD6cKeczc-SNK/view?usp=sharing',
    },
    {
        id : 15,
        program :'Q3 IIC Calender Activity 16.03.2022  as a Resource Person',
        pdf : 'https://drive.google.com/file/d/1oEFh7fJI9fAha5KlypqviULAb3AuJnZL/view?usp=sharing',
    },
    {
        id : 16,
        program :'Q3 IIC CalenderActivity Workshop on BMC',
        pdf : 'https://drive.google.com/file/d/1bw-ZWgtUA0HD8MSxbwxpOnH9ZUJUb25P/view?usp=sharing',
    },
    {
        id : 17,
        program :'Q3 IIC CalenderActivity Workshop on Prototype Des and Dev',
        pdf : 'https://drive.google.com/file/d/1nn0aiGdYlBdh1yXfGkZSren8Yi3XWnVk/view?usp=sharing',
    },
    {
        id : 18,
        program :'Q3 IIC Self Driven Activity 20.04.2022  National Level Sympo ECE',
        pdf : 'https://drive.google.com/file/d/1M2dlbqtBXi3rVlJK4DpIcibDkwg4VwGX/view?usp=sharing',
    },
    {
        id : 19,
        program :'Q3 IIC Self Driven Activity IPR Workshop Participation IEDP',
        pdf : 'https://drive.google.com/file/d/1UNoZX6mejb-nkKtAbdexiHPD8etWIbdJ/view?usp=sharing',
    },
    {
        id : 20,
        program :'Q4 IIC CalAct on 24.08.2022 Lean Start-up Camp_ Minimum Viable Product / Business',
        pdf : 'https://drive.google.com/file/d/1HPfs4ITDafq6T3UhBYC3yn2n-Bd_gkYD/view?usp=sharing',
    },
    {
        id : 21,
        program :'TCE Ideation Camp Partcipation 21.03.2022',
        pdf : 'https://drive.google.com/file/d/1Dg9h-E5SOd80acoltv3XOf3_Ih4Mo8nP/view?usp=sharing',
    },
]